import axios from 'axios';


axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth-token');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
}, (err) => {
  Promise.reject(err);
});

const getApiUrl = (path, params) => {
  // Encode the values, otherwise a search term containing & or # breaks the
  // request. Undefined and null values are dropped so optional filters can
  // simply be left unset by the caller.
  const query = Object.entries(params || {})
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  const p = query ? `?${query}` : '';

  if (path.includes('http://') || path.includes('https://') || path.startsWith('/api')) {
    // In case the passed url is a full url;
    return `${path}${p}`;
  }
  return `/api/${path}${p}`;
};

const getErrorResponse = (error) => (
  error.response || {
    status: 0,
    data: null,
    error,
    isNetworkError: true,
  }
);

export default {
  delete: async (path, data) => {
    try {
      return await axios.delete(
        getApiUrl(path), {
          data,
        },
      );
    } catch (e) {
      return getErrorResponse(e);
    }
  },
  get: async (path, queryParams) => {
    try {
      return await axios.get(
        getApiUrl(path, queryParams),
      );
    } catch (e) {
      return getErrorResponse(e);
    }
  },
  getFile: async (path) => {
    try {
      return await axios({
        url: path,
        method: 'GET',
        responseType: 'blob',
      });
    } catch (e) {
      return getErrorResponse(e);
    }
  },
  patch: async (path, data, headers) => {
    try {
      return await axios.patch(
        getApiUrl(path),
        data || {},
        {
          headers: headers || {},
        },
      );
    } catch (e) {
      return getErrorResponse(e);
    }
  },
  post: async (path, data, queryParams, headers) => {
    try {
      return await axios.post(
        getApiUrl(path, queryParams),
        data || {},
        {
          headers: headers || {},
        },
      );
    } catch (e) {
      return getErrorResponse(e);
    }
  },
  put: async (path, data, headers) => {
    try {
      return await axios.put(
        getApiUrl(path),
        data || {},
        {
          headers: headers || {},
        },
      );
    } catch (e) {
      return getErrorResponse(e);
    }
  },
};
